// JsFromRoutes CacheKey 42f1a6524dfdcf499f75692acdae153d
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@corp/services/api'

export default {
  search: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/landing_page_sections/search'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/landing_page_sections'),
  create: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/landing_page_sections'),
  update: /* #__PURE__ */ definePathHelper('patch', '/admin/consumer/landing_page_sections/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/admin/consumer/landing_page_sections/:id'),
}
